"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DealerTile", {
  enumerable: true,
  get: function () {
    return _DealerTile.default;
  }
});
Object.defineProperty(exports, "ModelTile", {
  enumerable: true,
  get: function () {
    return _ModelTile.default;
  }
});
exports.TileGrid = void 0;
Object.defineProperty(exports, "VehicleTile", {
  enumerable: true,
  get: function () {
    return _VehicleTile.default;
  }
});
exports.default = void 0;
exports.getTileGridId = getTileGridId;
var _react = _interopRequireWildcard(require("react"));
var _reactVirtuoso = require("react-virtuoso");
var _styledComponentThemes = require("../../_nextgen/packages/styled-component-themes");
var _Text = _interopRequireDefault(require("../Text"));
var _analytics = _interopRequireWildcard(require("../analytics"));
var _DealerTile = _interopRequireDefault(require("./DealerTile"));
var _ModelTile = _interopRequireDefault(require("./ModelTile"));
var _VehicleTile = _interopRequireDefault(require("./VehicleTile"));
var Styled = _interopRequireWildcard(require("./index.styled"));
var Themes = _interopRequireWildcard(require("./index.themes"));
var _jsxRuntime = require("react/jsx-runtime");
function getTileGridId() {
  var _val$replaceAll;
  let val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "model";
  return `${val === null || val === void 0 ? void 0 : (_val$replaceAll = val.replaceAll(/\W/g, "")) === null || _val$replaceAll === void 0 ? void 0 : _val$replaceAll.replaceAll(/\s+/g, "_")}_list`;
}
const TileGrid = function (props) {
  const {
    heading,
    variation = "MLP",
    disclaimer,
    children,
    disableVirtualization = false,
    classNameTileGrid
  } = props;
  const fireAnalytics = (0, _analytics.default)("TileGrid", {});
  const childrenArray = _react.default.Children.toArray(children);
  const ListComponent = variation === "VLP" ? Styled.VLPTileContainer : Styled.TileContainer;
  const renderItem = _react.default.useCallback(function (index) {
    return childrenArray[index];
  }, [childrenArray]);
  const hasDisclaimer = !!disclaimer;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: props === null || props === void 0 ? void 0 : props.className,
    "data-testid": "TileGrid",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.TileGrid, {
      id: getTileGridId(heading),
      className: classNameTileGrid,
      children: [heading && /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Heading, {
        hasDisclaimer: hasDisclaimer,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          children: heading
        })
      }), disclaimer && /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Disclaimer, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          children: disclaimer
        })
      }), !disableVirtualization ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactVirtuoso.VirtuosoGrid, {
        context: {
          variation
        },
        totalCount: childrenArray.length,
        useWindowScroll: true,
        components: {
          List: ListComponent
        },
        overscan: 2000,
        itemContent: renderItem
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(ListComponent, {
        children: childrenArray.map(function (i) {
          return i;
        })
      })]
    })
  });
};
exports.TileGrid = TileGrid;
const ThemedTileGrid = (0, _styledComponentThemes.withThemes)(TileGrid, Themes);
var _default = exports.default = /*#__PURE__*/(0, _react.memo)((0, _analytics.withAnalytics)(ThemedTileGrid)({}));